"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pcl = require("postchain-client");
var index_1 = require("./index");
var KeyPair = /** @class */ (function () {
    function KeyPair(privateKey) {
        this.makeKeyPair = function () {
            return pcl.util.makeKeyPair();
        };
        if (privateKey) {
            this.privKey = index_1.hexToBuff(privateKey);
            this.pubKey = pcl.util.createPublicKey(this.privKey);
        }
        else {
            var _a = this.makeKeyPair(), pubKey = _a.pubKey, privKey = _a.privKey;
            this.pubKey = pubKey;
            this.privKey = privKey;
        }
    }
    return KeyPair;
}());
exports.default = KeyPair;
//# sourceMappingURL=keyPair.js.map